



















































import { addBasePath } from '~/helpers/addBasePath';
import SfButton from './SfButton/SfButton.vue';
import SfIcon from './SfIcon.vue';
import SfImage from './SfImage.vue';

export default {
  name: 'SfBar',
  components: {
    SfIcon,
    SfButton,
    SfImage,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    back: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      addBasePath,
    };
  },
};
